import React from 'react'
import { Modal } from 'antd'
import { ERoles } from 'models/auth'
import { Order } from 'pages/admin/Orders/Order/Order'
import { OrderEdit } from 'pages/superAdmin/Orders/Edit/OrderEdit'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { bodyScrollLock } from 'shared/utils/bodyScrollLock'
import { appSelectors } from 'store/app'
import styles from './OrderModal.module.scss'

interface IOrderModalProps {
  // null — модалка закрыта
  orderId: string | null
  onClose: () => void
}

// Внутри та же страница, что открывается по /orders/:id для этой роли
export const OrderModal: React.FC<IOrderModalProps> = ({ orderId, onClose }) => {
  const role = useAppSelector(appSelectors.selectRole)
  const open = Boolean(orderId)
  // Заказ держим и после закрытия, иначе модалка опустеет прямо во время анимации ухода
  const lastOrderIdRef = React.useRef(orderId)
  if (orderId) {
    lastOrderIdRef.current = orderId
  }
  const shownOrderId = orderId ?? lastOrderIdRef.current

  React.useEffect(() => {
    if (!open) {
      return
    }
    bodyScrollLock.enable()
    return () => bodyScrollLock.disable()
  }, [open])

  const embedded = shownOrderId ? { orderId: shownOrderId, onClose } : null

  return (
    <Modal
      centered
      destroyOnClose
      open={open}
      onCancel={onClose}
      footer={null}
      wrapClassName={styles.wrapper}
      className={styles.modal}
    >
      {embedded && (role === ERoles.ADMIN
        ? <OrderEdit key={embedded.orderId} embedded={embedded} />
        : <Order key={embedded.orderId} embedded={embedded} />)}
    </Modal>
  )
}
